import { em } from 'polished'
import styled from 'styled-components'

export const EatIcon = styled.img`
  width: ${em(66)};
`
